// These are the stock Material-UI breakpoint values
export var defaultBreakpointValues = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
}; // Casting to avoid passing a useless `xxl`
export var legacyBreakpoints = {
    values: defaultBreakpointValues,
    keys: Object.keys(defaultBreakpointValues),
};
//# sourceMappingURL=legacyBreakpoints.js.map